export const darkThemeColors = {
  brandDark: 'rgb(33, 147, 176)',
  brandLight: 'rgb(109, 213, 237)',
  brandLighter: '#04617a',
  text: '#FFF',
  textLight: '#c6c4c9',
  lightest: '#FFFFFD',
  accent1: '#C56DED',
  accent2: '#ED856D',
  accent3: '#95ED6D',
  compliment: '#ED856D',
};

export const lightThemeColors = {
  brandDark: 'rgb(33, 147, 176)',
  brandLight: 'rgb(109, 213, 237)',
  brandLighter: '#04617a',
  text: '#FFF',
  textLight: '#c6c4c9',
  lightest: '#000',
  accent1: '#C56DED',
  accent2: '#ED856D',
  accent3: '#95ED6D',
  compliment: '#ED856D',
};

export const selectTheme = (window) => {
  if (window.sessionStorage.getItem("darkMode") === "on") {
    return darkThemeColors;
  }
  return lightThemeColors;
}

export const breakpoints = {
  mobile: 400,
  phablet: 550,
  tablet: 750,
  desktop: 1000,
  hd: 1300
};

export const spacing = {
  '3xs': 2,
  '2xs': 4,
  xs: 8,
  sm: 12,
  md: 16,
  lg: 24,
  xl: 32,
  '2xl': 40,
  '3xl': 48
};

export const defaultFontStack = [
  '-apple-system',
  'BlinkMacSystemFont',
  'Segoe UI',
  'Roboto',
  'Oxygen',
  'Ubuntu',
  'Cantarell',
  'Open Sans',
  'Helvetica Neue',
  'sans-serif'
].join();

const monospaceFontStack = [
  `Space Mono`,
  `SFMono-Regular`,
  `Menlo`,
  `Monaco`,
  `Consolas`,
  `Liberation Mono`,
  `Courier New`,
  `monospace`
].join();

export const fonts = {
  body: defaultFontStack,
  heading: `Futura PT, ${defaultFontStack}`,
  monospace: monospaceFontStack
};
